import { AdminMixerService } from '@linktivity/triplabo-taxfree';
import { config as env } from '@link/admin/utils/env';
import {
  AUTH_HEADER,
  getAccessToken,
  redirectToLogin,
  refreshAccessToken
} from './auth';

const replay = (url: string, init: RequestInit) => {
  const headers = new Headers(init.headers);
  headers.set(AUTH_HEADER, getAccessToken());

  return fetch(url, { ...init, headers });
};

const config = new AdminMixerService.Configuration({
  basePath: env.apiBase,
  apiKey: getAccessToken,
  middleware: [
    {
      post: async ({ url, init, response }) => {
        if (response.status !== 401) {
          return;
        }

        const sentToken = new Headers(init.headers).get(AUTH_HEADER);
        const currentToken = getAccessToken();

        const refreshedByOther =
          sentToken && currentToken && sentToken !== currentToken;

        if (refreshedByOther) {
          return replay(url, init);
        }

        const refreshed = await refreshAccessToken();

        if (!refreshed) {
          redirectToLogin();
          return;
        }

        return replay(url, init);
      }
    }
  ]
});

export default config;
